import { Alert, Snackbar } from '@mui/material';
import type { ColumnMetadata } from '../grid/types';
import type { JsMethodHost } from './registry';
import {
  useJsMethodNotifications,
  useUnsupportedJsMethodNotifications,
  type JsMethodNotificationState,
} from './useJsMethodNotifications';

export const JsMethodNotificationToast = ({
  current,
  onClose,
}: {
  current: JsMethodNotificationState;
  onClose: () => void;
}) => (
  <Snackbar
    key={current?.message}
    open={current != null}
    autoHideDuration={current?.severity === 'error' ? 8000 : 5000}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
  >
    <Alert severity={current?.severity ?? 'warning'} variant="filled" onClose={onClose}>
      {current?.message}
    </Alert>
  </Snackbar>
);

export const JsMethodSupportNotifier = ({
  fields,
  host,
}: {
  fields: ColumnMetadata[];
  host: JsMethodHost;
}) => {
  const { current, dismiss, notify } = useJsMethodNotifications();
  useUnsupportedJsMethodNotifications(fields, host, notify);

  return <JsMethodNotificationToast current={current} onClose={dismiss} />;
};
